import { p as parseCookies, g as getRootDomain, a as setCookieValue } from "../../../cookies-56ad18bd.js";
import "../../../utils/logger.es.js";
const getMerkleIds = () => {
  const timeout = 350;
  if (typeof window === "undefined") {
    return Promise.resolve(null);
  }
  const cookies = parseCookies();
  return new Promise((resolve) => {
    const existingData = window._svDataLayer;
    if (existingData) {
      setCookies(existingData);
      resolve({
        merkury_confidence_score: (existingData == null ? void 0 : existingData.confidence_score) ?? ((cookies == null ? void 0 : cookies.eh_merkury_confidence_score) ? Number(cookies.eh_merkury_confidence_score) : null),
        merkury_cmid: (existingData == null ? void 0 : existingData.merkury_id_cmid) ?? ((cookies == null ? void 0 : cookies.eh_merkury_cmid) ?? null),
        merkury_hmid: (existingData == null ? void 0 : existingData.merkury_id_hmid) ?? ((cookies == null ? void 0 : cookies.eh_merkury_hmid) ?? null)
      });
      return;
    }
    const timeoutId = setTimeout(() => {
      resolve(null);
    }, timeout);
    window.addEventListener("_svdatalayer_ready", () => {
      clearTimeout(timeoutId);
      const merkleData = window._svDataLayer;
      if (!merkleData) {
        resolve({
          merkury_confidence_score: (cookies == null ? void 0 : cookies.eh_merkury_confidence_score) ? Number(cookies.eh_merkury_confidence_score) : void 0,
          merkury_cmid: (cookies == null ? void 0 : cookies.eh_merkury_cmid) ?? void 0,
          merkury_hmid: (cookies == null ? void 0 : cookies.eh_merkury_hmid) ?? void 0
        });
        return;
      }
      setCookies(merkleData);
      resolve({
        merkury_confidence_score: (merkleData == null ? void 0 : merkleData.confidence_score) ?? ((cookies == null ? void 0 : cookies.eh_merkury_confidence_score) ? Number(cookies.eh_merkury_confidence_score) : null),
        merkury_cmid: (merkleData == null ? void 0 : merkleData.merkury_id_cmid) ?? ((cookies == null ? void 0 : cookies.eh_merkury_cmid) ?? null),
        merkury_hmid: (merkleData == null ? void 0 : merkleData.merkury_id_hmid) ?? ((cookies == null ? void 0 : cookies.eh_merkury_hmid) ?? null)
      });
    });
  });
};
const setCookies = (merkleData) => {
  const rootDomain = getRootDomain(window.location.hostname);
  const cookieOptions = {
    domain: rootDomain,
    httpOnly: false,
    path: "/"
  };
  setCookieValue(
    "eh_merkury_confidence_score",
    (merkleData == null ? void 0 : merkleData.confidence_score) || void 0,
    cookieOptions
  );
  setCookieValue(
    "eh_merkury_cmid",
    (merkleData == null ? void 0 : merkleData.merkury_id_cmid) || void 0,
    cookieOptions
  );
  setCookieValue(
    "eh_merkury_hmid",
    (merkleData == null ? void 0 : merkleData.merkury_id_hmid) || void 0,
    cookieOptions
  );
};
export {
  getMerkleIds
};
